<div class="modal-header">
  <h3 class="modal-title">Search for new user</h3>
  <div class="header-actions">
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body">
  <div class="search-box">
    <input
      type="text"
      class="form-control"
      placeholder="Enter keyword to search"
      [(ngModel)]="selectedUser"
      (ngModelChange)="getUsers()"
    />
    <div class="buttons">
      <button class="btn btn-warning btn-sm" type="button" (click)="switchUser()" [disabled]="switchReset || loading">Switch User</button>
      <button class="btn btn-warning btn-sm" type="button" (click)="reset()" [disabled]="loading">Reset</button>
    </div>
  </div>

  @if (loading) {
<div><i class="fa fa-spinner fa-pulse"></i> Loading...</div>
}

  @if (showList) {
<ul class="list-group">
    @for (user of userDetailsArr; track $index) {
<li class="list-group-item" (click)="fillTextbox(user)">
      {{ user }}
    </li>
}
  </ul>
}

  @if (noRecords) {
<span class="no-records">No Records Found.</span>
}
</div>
